<template>
  <div id="m-mobile-newD">
    <div class="news-title">
      <h1>{{trendsDetail.ftitle}}</h1>
      <div>
        <span>发布时间：{{trendsDetail.freleaseDate}}</span>
<!--        <span>信息来源：</span><span class="span3">浏览次数：0</span>-->
      </div>
    </div>
    <div>
      <img :src="baseUrl + trendsDetail.fimgUrl" width="100%"/>
    </div>
    <div style="margin-top: 2.4rem;" v-html="trendsDetail.fcontent">

    </div>
  </div>
</template>

<script>
  import axios from "../../../../static/js/commonAxios";

  export default {
    name: "mobileNewsDetail",
    data(){
      return{
        newsId:this.$route.query.id,
        trendsDetail: '',
        baseUrl: ''
      }
    },
    mounted(){
      this.baseUrl = process.env.API_ROOT;
      this.getTrendDetailDate(this.newsId)
    },
    methods: {
      getTrendDetailDate(id){
        axios.get(`/api/selectNews`,{
          'params':{
            "fnewsId":id
          }
        }).then((res) => {
          if(res.data.success){
            this.trendsDetail = res.data.items[0]
          }else{
            this.$message({
              type: 'warning',
              message: res.data.msg
            });
          }
        })
      },
    },
  }
</script>

<style>
  #m-mobile-newD {
    margin-top: 3.25rem;
    padding: 1.5rem;
  }
  #m-mobile-newD .news-title h1{
    font-size: 1.25rem;
    font-weight: 500;
    color: #333333;
  }
  #m-mobile-newD .news-title span{
    display: inline-block;
    font-size: 0.81rem;
    font-weight: 400;
    color: #9E9E9E;
    padding: 1.22rem 0 1.53rem 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Mobile/mobileNews/mobileNewsDetail.vue